import { applicationsGetters } from './routines'

const CLOSED = ['Successful', 'Closed']

const getApplications = deal => (Array.isArray(deal?.applications) ? deal.applications : [])

// Mirrors DealSection's `subtypeApps` check: a deal is only actionable by the user when it has a
// default-subtype application, because that is what the "Provide information" button routes to.
// Keep this in step with DealSection.vue or the sidebar count and the buttons on screen will diverge.
const hasActionableApplication = deal => getApplications(deal).some(app => app?.isDefaultSubTypeProduct)

export default {
  [applicationsGetters.DEALS]: state => state.deals,
  [applicationsGetters.IS_LOADING]: state => state.isLoading,
  [applicationsGetters.HAS_ERROR]: state => state.hasError,
  [applicationsGetters.LAST_FETCHED_AT]: state => state.lastFetchedAt,

  [applicationsGetters.LIVE_DEALS]: state => state.deals.filter(d => d.dealStatus !== 'NA' && !CLOSED.includes(d.dealStatus)),

  [applicationsGetters.CLOSED_DEALS]: state => state.deals.filter(d => CLOSED.includes(d.dealStatus)),

  [applicationsGetters.INFORMATION_REQUESTED_DEALS]: state => state.deals.filter(d => d.dealStatus === 'InformationRequested'),

  [applicationsGetters.INFORMATION_REQUESTED_COUNT]: (state, getters) => getters[applicationsGetters.INFORMATION_REQUESTED_DEALS].length,

  [applicationsGetters.HAS_INFORMATION_REQUESTED]: (state, getters) => getters[applicationsGetters.ACTIONABLE_INFORMATION_REQUESTED_COUNT] > 0,

  [applicationsGetters.IS_STALE]: state => {
    const FIVE_MIN = 5 * 60 * 1000
    return Date.now() - state.lastFetchedAt > FIVE_MIN
  },

  // Only counts deals the user can actually act on. Counting every InformationRequested deal would
  // tell them 3 things need attention when only 1 offers them a button to press.
  [applicationsGetters.ACTIONABLE_INFORMATION_REQUESTED_COUNT]: (state, getters) => getters[applicationsGetters.INFORMATION_REQUESTED_DEALS].filter(hasActionableApplication).length
}
